define('home/templates/channelDiscussionFeed',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.escapeExpression, alias2=depth0 != null ? depth0 : {};

  return "<div class=\"card-wrap -padded\">\n<a href=\"/home/discuss/"
    + alias1(container.lambda(((stack1 = ((stack1 = (depth0 != null ? depth0.channel : depth0)) != null ? stack1.primaryForum : stack1)) != null ? stack1.id : stack1), depth0))
    + "/\" class=\"button button-padding-taller button-wide\">\n<div class=\"align align--between align--middle\">\n<div class=\"align__item\">\n<span class=\"icon-create-discussion text-small icon__position -inline\"></span>\n"
    + alias1(helpers.gettext.call(alias2,"What do you want to discuss?",{"name":"gettext","hash":{},"data":data}))
    + "\n</div>\n<div class=\"align__item\">\n<button class=\"button button-outline text-medium\">"
    + alias1(helpers.gettext.call(alias2,"Discuss",{"name":"gettext","hash":{},"data":data}))
    + "</button>\n</div>\n</div>\n</a>\n</div>\n";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers.unless.call(depth0 != null ? depth0 : {},((stack1 = ((stack1 = (depth0 != null ? depth0.channel : depth0)) != null ? stack1.options : stack1)) != null ? stack1.isCurationOnlyChannel : stack1),{"name":"unless","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "<div data-role=\"content-area\"></div>\n<div data-role=\"footer-area\"></div>\n";
},"useData":true})

});
